import React from 'react';

const SkeletonParagraph = ({ lines = 5, isHighlighted = false }) => {
  const baseStyle = {
    backgroundColor: isHighlighted ? '#87888C' : '#e0e0e0',
    borderRadius: '4px',
    height: '12px',
    marginBottom: '12px',
    animation: 'pulse 1.5s infinite ease-in-out',
  };

  const lineStyles = Array.from({ length: lines }).map((_, idx) => {
    const width = `${80 + Math.random() * 20}%`; // Random width 80–100%
    return (
      <div
        key={idx}
        style={{
          ...baseStyle,
          width,
        }}
      />
    );
  });

  return (
    <div>
      <style>
        {`
          @keyframes pulse {
            0% { opacity: 1; }
            50% { opacity: 0.4; }
            100% { opacity: 1; }
          }
        `}
      </style>
      {lineStyles}
    </div>
  );
};

export default SkeletonParagraph;
